import{jsx as o,jsxs as e,Fragment as i}from"react/jsx-runtime";import d from"@atlaskit/spinner";import r from"@atlaskit/tooltip";import{useState as l,useCallback as n,useEffect as t}from"react";import s from"styled-components";import a from"./ItemContent.js";import{Info as u,SpinnerContainer as c}from"./styled.js";const p=s.div`
	position: relative;

	width: 320px;
	height: 100px;
	box-sizing: border-box;
	padding: 20px;

	background-color: ${({isGrayed:o,grayedBackgroundColor:e,backgroundColor:i})=>o?e||"#f1f2f4":i};

	border-radius: ${({borderRadius:o})=>`${void 0!==o?o:3}px`};
	border: ${({isSelected:o})=>"1px solid "+(o?"#4C9AFF":"transparent")};
	box-shadow: ${({boxShadow:o})=>o};

	display: flex;
	align-items: center;
	column-gap: 12px;

	.delete-action {
		opacity: 0;
		transition: opacity 100ms linear;
	}

	&:hover {
		.delete-action {
			opacity: 1;
		}
	}
`;function m({node:s,userInfo:m,selectedUser:f,isLoading:v,getUserValueFromField:b,additionalProps:h,darkTheme:g,children:x}){const[y,k]=l(""),[C,F]=l(""),{viewOptions:I,userRecords:w,fields:j,shouldCheckCosmosLicense:S,isCosmosInstalled:G,onItemClick:R}=h||{},{borderRadius:$,titleFieldId:O,footerFieldId:V,color:A}=I||{},E=!S||!!G,L=n((o=>{if(!E||!o||!(null==s?void 0:s.id))return"";const e=null==w?void 0:w.find((o=>o.accountId===s.id));if(!e)return"";return(null==j?void 0:j.find((e=>e.id===o||e.value===o)))?b(null==e?void 0:e.values,j,o):""}),[null==s?void 0:s.id,j,w,E]);return t((()=>((null==s?void 0:s.id)&&(k(L(O)),F(L(V))),()=>{k(""),F("")})),[null==s?void 0:s.id,L,O,V]),(null==m?void 0:m.error)?o(p,Object.assign({isGrayed:!1,borderRadius:$||3,isSelected:!1},{children:o(u,{children:"Failed to load user."})})):o(r,Object.assign({content:(null==s?void 0:s.isGrayed)?"Not in filter":""},{children:e(p,Object.assign({isGrayed:!!(null==s?void 0:s.isGrayed),borderRadius:$||3,isSelected:(null==f?void 0:f.id)===(null==m?void 0:m.key),backgroundColor:null==g?void 0:g.backgroundColor,boxShadow:null==g?void 0:g.boxShadow,style:{cursor:R?"pointer":"default"},onClick:()=>{R&&R(null==s?void 0:s.id)}},{children:[v?o(c,{children:o(d,{})}):o(a,{viewType:"list",userInfo:m,color:A||"#4C9AFF",firstElementValue:y,secondElementValue:C}),x||o(i,{})]}))}))}export{m as default};
